import * as Styles from './styles';

export const ButtonContainerLeft = ({children}) => {
    return(
        <Styles.LeftItems>
            {children}
        </Styles.LeftItems>
    )
}
    

